import CommunicationLogUI from './CommunicationLogUI';

export default CommunicationLogUI;
 
